

























import { Vue, Component } from "vue-property-decorator";
import { data, secret } from "./agreement";
@Component
export default class Agreement extends Vue {
  data = data;
  secret = secret;
}
